export const debounce = <T extends Function>(cb: T, wait = 200) => {
  let h = 0;

  return (...args: any) => {
    clearTimeout(h);
    h = setTimeout(() => cb(...args), wait);
  };
};
